import { WorkspaceListTable as View } from 'ui-components'

import { useGetWorkspaces } from 'workspaces/queries/useGetWorkspaces'

export function WorkspaceListTable() {
  const { items } = useGetWorkspaces()
  return <View items={items} />
}
